// extracted by mini-css-extract-plugin
export default {"tooltip":"Ap-z","sharingV2":"Bp-z","sharingIconsV2":"Cp-z","links":"Dp-z","link":"Ep-z","facebookV2":"Fp-z","twitterV2":"Gp-z","pinterestV2":"Hp-z"};